export const ProgressBar = {
  data() {
    return {
      routes: {
        estimate: 1,
        home: 2,
        confirm: 3
      }
    };
  },
  computed: {
    showProgress() {
      // Only show on these routes
      return ["estimate", "home", "confirm"].includes(this.$route.name);
    },
    currentStep() {
      // Get step number based on current route
      return this.routes[this.$route.name] || 0;
    },
    progressPercentage() {
      // Calculate percentage (0%, 50%, or 100%)
      return ((this.currentStep - 1) / 2) * 100;
    }
  },
  watch: {
    // Watch for route changes
    $route(to) {
      console.log("Route changed:", to.name, "Current step:", this.currentStep);
    }
  },
  template: "#progress-bar"
};
